import { fileApiProvider } from './fileApiProvider';
import { filePickerProvider } from './filePickerProvider';
import type { StorageProvider } from './provider';

/**
 * Uses the filePickerProvider if available, otherwise falls back to the fileApiProvider.
 */
export const fileProvider: StorageProvider =
  'showOpenFilePicker' in window ? filePickerProvider : fileApiProvider;
